import React from "react";

export function Review() {
     return (
          <button type="button" class="btn btn-lg" style={{ backgroundColor: "#2f56a1", color: "white", width: "150px" }}>Review</button>
     );
}
